export class TransferCallAction {
   public static readonly type = '[TransferState] Transfer call to Dialpadnumber or selected number';
   constructor() {}
}
